<div
  class="inline-block"
  [ngClass]="{ 'w-full': fullWidth, 'opacity-50': uiDisabled, 'w-48': !basicUI }"
>
  <div>
    <div>
      <label [ngClass]="{ 'pl-4 text-sm text-gray-500 font-light text-right': basicUI }">
        {{ label }} {{ required && "*" }}
      </label>
      <div class="relative" [ngClass]="{ 'basic-dropdown': basicUI }">
        <div
          [ngClass]="{
            opened: dropdownOpened,
            'cursor-pointer': !dropdownOpened,
            'bg-gray-lighter border-gray-400': theme === 'gray',
            'bg-white border rounded w-full text-right': !basicUI
          }"
          (click)="toggle(true)"
          class="dropdown-input flex justify-between text-sm mt-1">
          <div
            class="appearance-none focus:outline-none pl-4 py-2 rounded"
            [ngClass]="{
              'bg-gray-lighter': theme === 'gray',
              'background-grey': disabled || formControl?.disabled
            }"
          >
            <div class="flex">
              <div
                class="px-1 mr-2 bg-gray-200 border-b border-gray-400 rounded cursor-default"
                (click)="$event.stopPropagation();"
                *ngFor="let input of inputValue; let i = index"
              >
                <ng-container *ngIf="input.type">
                  <i *ngIf="input.type.icon" class="material-icons mt-1 md-16 {{ input.type.color }}"
                    >{{ input.type.icon }}
                  </i>
                  <span *ngIf="!input.type.icon">{{ input.type.code }}</span>
                </ng-container>
                <span *ngIf="!input.type" class="flex-1">{{ input.text }}</span>
                <span (click)="removeInput(i)" class="flex-1 ml-1 right-0 cursor-pointer">x</span>
              </div>
            </div>
          </div>
          <div
            class="pt-2 pr-1 absolute right-0"
            [style]="{ top: '-1px' }"
            *ngIf="!uiDisabled">
            <mat-icon [@rotate]="dropdownOpened">expand_more</mat-icon>
          </div>
        </div>
        <div
          *ngIf="dropdownOpened"
          class="dropdown-list-container w-48"
          [ngClass]="{ 'w-full': fullWidth, backwards: isBackwards }"
          [@enterAnimation]
        >
          <ul class="dropdown-list overflow-y-auto" [ngClass]="{ opened: dropdownOpened }">
            <app-multi-select-dropdown-list-item
              *ngIf="
                defaultOption &&
                (inputValue === null || inputValue === undefined || inputValue === [])
              "
              class="dropdown-list-item"
              (click)="selectOption(defaultOption)"
              (keydown)="handleKeydown($event, defaultOption)"
              [option]="defaultOption.text"
              [type]="defaultOption.type"
            >
            </app-multi-select-dropdown-list-item>
            <app-multi-select-dropdown-list-item
              *ngFor="let option of options"
              (click)="selectOption(option)"
              (keydown)="handleKeydown($event, option)"
              [option]="option.text"
              [type]="option.type"
            >
            </app-multi-select-dropdown-list-item>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
